import { ESuitSymbol } from '../enums'
import { blackSuitCard, redSuitCard } from '../index.css'

export const cardClassNameBySuit: Record<ESuitSymbol, string> = {
  [ESuitSymbol.CLUB]: blackSuitCard,
  [ESuitSymbol.DIAMOND]: redSuitCard,
  [ESuitSymbol.HEART]: redSuitCard,
  [ESuitSymbol.SPADE]: blackSuitCard,
}
